'use strict';

const DateUtils = require('utils/DateUtils');
const RECEVIED_STATE = [
    'RECEIVED',
    'ORDER_PARTIALLY_RECEIVED',
    'RECEIVED_WITH_ISSUE',
    'CLOSED_COMPLETE',
    'CLOSED_COMPLETE_PAID',
    'CLOSED_RESOLVED',
    'CLOSED_RESOLVED_PAID'
];
const get = require('lodash/object').get;


const PurchaseOrderUtils = {

    getDaysLeftToBeReceivedFromPurchaseOrder(purchaseOrder, t, toDayDate = new Date()) {

        const amountDays = DateUtils.getDaysBetween(
            DateUtils.toDate(DateUtils.toDateText(toDayDate)),
            purchaseOrder.latestArrivalDate
        );

        const isReceived = RECEVIED_STATE.indexOf(get(purchaseOrder, 'state')) > -1;
        if (isReceived) {
            return `${t('purchase_state_received')} (${DateUtils.toDateText(purchaseOrder.receivedDate)})`;
        }

        if (amountDays < 0) {
            return `${t('overdue')} (${Math.abs(amountDays)} ${t('days')})`;
        } else {
            return amountDays;
        }
    },

    getLastReceivedDateFromPurchaseOrder(purchaseOrder) {
        if (purchaseOrder.partiallyReceivedDate) {
            return purchaseOrder.partiallyReceivedDate;
        }
        if (purchaseOrder.receivedWithIssuesDate) {
            return purchaseOrder.receivedWithIssuesDate;
        }

        if (purchaseOrder.receivedDate) {
            return purchaseOrder.receivedDate;
        }
    },

    getLastReceivedDateFromPurchaseOrderItem(purchaseOrderItem) {
        if (purchaseOrderItem.rejectRemainderDate) {
            return purchaseOrderItem.rejectRemainderDate;
        }
        if (purchaseOrderItem.noMoreOnTheWayDate) {
            return purchaseOrderItem.noMoreOnTheWayDate;
        }

        if (purchaseOrderItem.moreOnTheWayDate) {
            return purchaseOrderItem.moreOnTheWayDate;
        }

        return undefined;
    },

    /**
     * Indicate if given {@link VendorPurchaseItem} could be changed/removed.
     * The only state which is able to deleted/changed it's PENDING, the rest of states
     * happens after the supplier was notified by email. So we no longer able to change it.
     * @param vendorPurchaseItem
     * @returns {boolean}
     */
    isAbleToChangeVendorPurchaseItem(vendorPurchaseItem) {
        return get(vendorPurchaseItem, 'state') === 'PENDING';
    },

    getPriceOfPurchaseItem(purchaseItem) {
        return get(purchaseItem, 'supplierPrice') || get(purchaseItem, 'priceUnit') || get(purchaseItem, 'vendorItem.priceUnit');
    }

};

module.exports = PurchaseOrderUtils;



/** WEBPACK FOOTER **
 ** ./src/utils/PurchaseOrderUtils.js
 **/